import React from 'react';
import { fmtDate, fmtMoney } from '@/lib/billingApi';
import { PlanSwitchDialog } from './PlanSwitchDialog';

const plusYear = (d) => { const x = new Date(d); x.setFullYear(x.getFullYear() + 1); return x; };

export const AnnualSwitchDialog = ({ sub, offer, onClose }) => {
  const price = fmtMoney(offer.annual_price, offer.currency);
  return (
    <PlanSwitchDialog
      onClose={onClose}
      testId="annual-switch"
      eyebrow="Switch to annual"
      title="Schedule Guru Pro — Annual"
      description="No days are lost: your year starts when the month you already paid for ends."
      facts={[
        { label: 'Due today', value: price, testId: 'annual-switch-due' },
        { label: 'Annual plan starts', value: fmtDate(sub.current_period_end), testId: 'annual-switch-starts' },
        { label: 'Next renewal', value: fmtDate(plusYear(sub.current_period_end)), testId: 'annual-switch-renews' },
        { label: 'Monthly renewals', value: 'Stop automatically' },
      ]}
      consentText={`I authorise Schedule Guru to charge this card ${price} now and ${price} each year on renewal until I cancel.`}
      payLabel={`Pay ${price} by card`}
      path={`/billing/subscriptions/${sub.id}/switch-annual`}
    />
  );
};
